import React from 'react';
import AddService from '../components/AddService';

const ServiceFormPage: React.FC = () => <AddService />;

export default ServiceFormPage;
